import PropTypes from 'prop-types';
import React from 'react';
import { Text } from '..';
import { DateUtils } from '@tripica/date-utils';

export const DateTimeLabel = props => {
  const timestamp = props.timestamp;
  const dateUtils = new DateUtils(() => props.localeGetter);

  const value = dateUtils.getDateTimeLabelDifferenceValue(timestamp);

  return <Text style={props.style}>{value}</Text>;
};

DateTimeLabel.propTypes = {
  timestamp: PropTypes.number.isRequired,
  style: PropTypes.any,
  localeGetter: PropTypes.any,
};
